import { delay } from "@/hooks/useReveal";

const STEPS = [
  ["We bring in the tools", "Verified AI tools for finance, accounting, HR and sales, set up in your workflow with the legal groundwork done before day one."],
  ["We hold the legal side", "EU AI Act, your internal AI policy, documentation and vendor contracts, all aligned with privacy law. The paperwork is ours."],
  ["You grow", "Try something new without waiting on regulation. Your team stays your team. We are the reinforcement, and the support when you need it."],
];

export const HowItWorks = () => (
  <section id="how" className="section section--navy surface-dark" aria-labelledby="how-title" data-testid="how-section">
    <div className="container">
      <div className="stack section-head" data-reveal>
        <p className="eyebrow">How it works</p>
        <h2 id="how-title" className="title">You choose the tools. We bring them in and hold the legal side.</h2>
      </div>
      <ol className="steps section-body">
        {STEPS.map(([title, text], i) => (
          <li className="step" key={title} data-reveal style={delay(i)}>
            <span className={`step__num${i === 2 ? " step__num--filled" : ""}`}>{i + 1}</span>
            <h3 className="step__title">{title}</h3>
            <p className="step__text">{text}</p>
          </li>
        ))}
      </ol>
    </div>
  </section>
);
